import { render, staticRenderFns } from "./SettingSubscription.vue?vue&type=template&id=87e3ac26&"
import script from "./SettingSubscription.vue?vue&type=script&lang=js&"
export * from "./SettingSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports